import styled from 'styled-components';
import { NavigationStyles } from '../../../../../Text/Navigation';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px;
`;

export const Text = styled.div`
  font-family: PublicSans-Regular;
  font-size: 14px;
  line-height: 16px;
  color: #464648;
  text-align: center;
  margin-bottom: 24px;
  margin-top: 8px;
`;

export const Link = styled(NavigationStyles)`
  margin-top: 20px;
  color: #101011;
  text-align: center;
  cursor: pointer;
`;
